export const environment = {
  production: true,
  dev: false,
  API_URL: null,
  STORAGE_URL: '',
  AVATAR_URL: '../../../../../assets/img/img_avatar.png'
};
